/**
 * RFC4122 v4 UUID generator. Pulled out of the legacy chatUtils.js port
 * because the same helper is needed by transport-level code (per-request
 * idempotency keys) and by message rendering. We don't reach for `crypto`
 * because shadow-DOM widgets can run inside iframes/sandboxes where the
 * Web Crypto API isn't always exposed.
 */
export function generateUuid() {
  let uuid = ''
  for (let ii = 0; ii < 32; ii += 1) {
    switch (ii) {
      case 8:
      case 20:
        uuid += '-'
        uuid += ((Math.random() * 16) | 0).toString(16)
        break
      case 12:
        uuid += '-'
        uuid += '4'
        break
      case 16:
        uuid += '-'
        uuid += (((Math.random() * 4) | 0) | 8).toString(16)
        break
      default:
        uuid += ((Math.random() * 16) | 0).toString(16)
    }
  }
  return uuid
}
